import type { JSX } from 'react'
import type { ILabelProps } from '../Label'

import { IconNames, IconSizes } from 'atoms/Icon'
import { COLOR } from 'vars/index'
import { Label } from '../Label'
import { Backgrounds, Corners, LabelsOrder, Paddings } from '../Label.h'

export type ILabelVerticalVideoProps = ILabelProps

export const LabelVerticalVideo = ({
  background = Backgrounds.ACCENT_SECONDARY,
  padding = Paddings.SIZE_100,
  color = COLOR.TEXT_ICON_PRIMARY,
  corners = Corners.CORNERS_10,
  order = LabelsOrder.ORDER_3,
  iconSize = IconSizes.small,
  icon = IconNames.verticalVideo,
  ...rest
}: ILabelVerticalVideoProps): JSX.Element => (
  <Label
    background={background}
    padding={padding}
    color={color}
    corners={corners}
    order={order}
    iconSize={iconSize}
    icon={icon}
    {...rest}
  />
)
